import { SimpleEventTypeLegacy, type SubjectVariableLegacy } from '@verantos-dev/types-cohorts';

import { transformSimpleEventTypeToGrammarSimpleEventType } from '../adapters/transformSimpleEventTypeToGrammarSimpleEventType';

export const getNextSubjectVariablesForSimpleEventNameChange = (
  subjectVariables: SubjectVariableLegacy[],
  referencedEventName: string,
  newReferencedEventName: string,
  newType: SimpleEventTypeLegacy | undefined
) => {
  return subjectVariables.map((subjectVariable) => {
    if (subjectVariable.countFilter) {
      return {
        ...subjectVariable,
        countFilter: {
          ...subjectVariable.countFilter,
          inputFields: subjectVariable.countFilter.inputFields.map((inputField, index) => {
            const countReferenceEventName = inputField.value?.split('::')[1];
            if (
              index === 0 &&
              countReferenceEventName?.slice(1, countReferenceEventName.length - 1) ===
                referencedEventName
            ) {
              return {
                ...inputField,
                value: `${transformSimpleEventTypeToGrammarSimpleEventType(
                  newType
                )}::"${newReferencedEventName}"`,
              };
            }
            return inputField;
          }),
        },
      };
    }
    return subjectVariable;
  });
};
